module.exports = __webpack_public_path__ + "img/b.2e6f2a0a.jpg";